import BreadCrumb from "../screens/MobileCommon/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/Mobilelayout/admin-dashboard";
import Home from "../screens/MobileCommon/home";
const breadCrumbData = [{ link: "/home", name: "Dashboard" }];

const HomePage = () => (
  <>
    <LayoutContainer>
      {/* <BreadCrumb data={breadCrumbData} /> */}
      <Home />
    </LayoutContainer>
  </>
);

export default HomePage;
